module.exports = __webpack_public_path__ + "static/media/BeverlyHills.21113f6a.jpg";